import Container from 'react-bootstrap/Container';
import styled from 'styled-components';

export const AppContainer = styled(Container).attrs({
  className: 'p-0',
  fluid: true,
})`
  // min-height: 100vh;
`;
